<template>
  <div class="container">
    <div class="topo">
      <img src="../assets/vettec.png" alt="Vetorial Internet" width="160px" height="100px" />
    </div>
    <div class="verificaCliente" v-if="mostraFormulario">
      <v-text-field v-model="emailCliente" label="Digite seu e-mail" :rules="emailErrors" required></v-text-field>
      <v-text-field
        v-model="codigoCliente"
        label="Digite o código enviado por e-mail"
        :rules="codigoClienteErros"
        v-on:keyup.enter="puxarDados"
        required
      ></v-text-field>
      <v-btn outlined large color="#AA1623" @click="puxarDados">Enviar</v-btn>
    </div>
    <div class="ctn" v-else>
      <h2 align="center">Ficha Cadastral</h2>
      <h3 align="center">Informações do Cliente</h3>
      <br />
      <v-form ref="form1">
        <v-container>
          <h5>Dados pessoais</h5>
          <span class="obrigatorios">Os itens marcados com * são obrigatórios!</span>

          <!-- Cabeçalho Pessoa Física -->
          <v-row v-if="tipoPessoa == 'Física'">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="formNome"
                label="Nome Completo *"
                :rules="formNomeErros"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                v-model="formCpf"
                :rules="cpfErrors"
                label="CPF *"
                v-mask="maskCpf"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field v-model="formRG" label="RG *" :rules="formRGErros" required></v-text-field>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="formEmail"
                :rules="emailErrors"
                label="E-mail *"
                required
                readonly
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- Fim cabeçalho Pessoa Física -->

          <!-- Cabeçalho Pessoa Jurídica -->
          <v-row v-else>
            <v-col cols="12" md="5">
              <v-text-field
                v-model="formNome"
                label="Razão Social *"
                :rules="formNomeErros"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                v-model="formCnpj"
                :rules="cnpjErrors"
                label="CNPJ *"
                v-mask="maskCnpj"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                v-model="formIE"
                label="Inscrição Estadual *"
                :rules="formIEErros"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                v-model="formIM"
                label="Inscrição Municipal *"
                :rules="formIMErros"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formNomeFantasia"
                :rules="formNomeFantasiaErros"
                label="Nome Fantasia *"
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="formEmail"
                :rules="emailErrors"
                label="E-mail *"
                required
                readonly
              ></v-text-field>
            </v-col>

            <!-- Fim cabeçalho Pessoa Jurídica -->
          </v-row>
          <br />
          <h5>Endereço e contato</h5>
          <v-row>
            <v-col cols="12" md="2">
              <v-text-field
                v-model="formCep"
                label="CEP *"
                v-mask="maskCep"
                @keyup="preencherCep1"
                :rules="formCepErros"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                v-model="formEndereco"
                label="Endereço *"
                :rules="formEnderecoErros"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field v-model="formNumero" label="Número *" :rules="formNumeroErros" required></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field v-model="formComplemento" label="Complemento"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="2">
              <v-text-field v-model="formBairro" label="Bairro *" :rules="formBairroErros" required></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field v-model="formCidade" label="Cidade *" :rules="formCidadeErros" required></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-select
                v-model="formEstado"
                :items="formEstados"
                :rules="[v => !!v || 'Selecione um estado']"
                label="Estado *"
                required
              ></v-select>
            </v-col>
            <!-- <v-col cols="12" md="2">
              <v-select
                v-model="formVencimento"
                :items="formVencimentos"
                label="Data de vencimento *"
                hint="Selecione o melhor dia para vencimento da Fatura."
                persistent-hint
                required
              ></v-select>
            </v-col> -->
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="formTel1"
                label="Telefone *"
                :rules="formTel1Erros"
                v-mask="['(##) ####-####', '(##) # ####-####']"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="formTel2"
                label="Telefone 2"
                v-mask="['(##) ####-####', '(##) # ####-####']"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model="formCel" v-mask="['(##) # ####-####']" label="Celular"></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <div class="formResponsavel">
        <h3>
          Responsável pela assinatura do contrato (sócio ou outorgado - com
          procuração, representante legal)
        </h3>
        <v-form ref="form2">
          <v-container>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="formNomeRespContrato"
                  label="Nome Completo *"
                  :rules="formNomeRespContratoErros"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="formCpfRespContrato"
                  :rules="cpfErrorsContrato"
                  label="CPF *"
                  v-mask="maskCpf"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="formCargoRespContrato"
                  label="Cargo Exercido *"
                  placeholder="Ex: Técnico"
                  :rules="formCargoRespContratoErros"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="formEmailRespContrato"
                  :rules="emailRespContratoErrors"
                  label="E-mail *"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="formTelRespContrato"
                  label="Telefone *"
                  :rules="formTelRespContratoErros"
                  v-mask="['(##) ####-####', '(##) # ####-####']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="formCelRespContrato"
                  v-mask="['(##) # ####-####']"
                  label="Celular"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </div>

      <h3>Responsável Técnico</h3>

      <v-checkbox v-model="mesmoRespTec" color="#AA1623" label="mesmo responsável do contrato"></v-checkbox>
      <transition name="fade">
        <div class="formResponsavelTecnico" v-if="!mesmoRespTec">
          <v-form ref="form3">
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="formNomeRespTecnico"
                    label="Nome Completo *"
                    :rules="[v => !!v || 'O nome deve ser preenchido']"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="formCpfRespTecnico"
                    :rules="cpfRespTecnicoErrors"
                    label="CPF *"
                    v-mask="maskCpf"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="formCargoRespTecnico"
                    label="Cargo Exercido *"
                    placeholder="Ex: Técnico"
                    :rules="[v => !!v || 'O Cargo deve ser preenchido']"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="formEmailRespTecnico"
                    :rules="emailRespTecnicoErrors"
                    label="E-mail *"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="formTelRespTecnico"
                    label="Telefone *"
                    v-mask="['(##) ####-####', '(##) # ####-####']"
                    :rules="[v => !!v || 'O telefone deve ser preenchido']"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="formCelRespTecnico"
                    label="Celular"
                    v-mask="['(##) # ####-####']"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </div>
      </transition>

      <h3>Responsável administrativo ou financeiro</h3>
      <v-checkbox v-model="mesmoRespAdm" color="#AA1623" label="mesmo responsável do contrato"></v-checkbox>
      <transition name="fade">
        <div class="formResponsavelAdministrativo" v-if="!mesmoRespAdm">
          <v-form ref="form4">
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field v-model="formNomeRespAdministrativo" label="Nome Completo *"></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="formCpfRespAdministrativo"
                    :rules="cpfRespAdministrativoErrors"
                    label="CPF *"
                    v-mask="maskCpf"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="formCargoRespAdministrativo"
                    label="Cargo Exercido *"
                    placeholder="Ex: Técnico"
                    :rules="[v => !!v || 'O Cargo deve ser preenchido']"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="formEmailRespAdministrativo"
                    :rules="emailRespAdministrativoErrors"
                    label="E-mail *"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="formTelRespAdministrativo"
                    label="Telefone *"
                    v-mask="['(##) ####-####', '(##) # ####-####']"
                    :rules="[v => !!v || 'O telefone deve ser preenchido']"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="formCelRespAdministrativo"
                    label="Celular"
                    v-mask="['(##) # ####-####']"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </div>
      </transition>
      <h3>Faturamento</h3>
      <v-checkbox v-model="mesmoEnderecoEmpresa" color="#AA1623" label="mesmo endereço da empresa"></v-checkbox>
      <transition name="fade">
        <div class="formEnderecoFaturamento" v-if="!mesmoEnderecoEmpresa">
          <v-form ref="form5">
            <v-container>
              <v-row>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="formCepFaturamento"
                    label="CEP *"
                    v-mask="maskCep"
                    :rules="formCepFaturamentoErros"
                    @keyup="preencherCep2"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="5">
                  <v-text-field
                    v-model="formEnderecoFaturamento"
                    label="Endereço *"
                    :rules="formEnderecoFaturamentoErros"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="formNumeroFaturamento"
                    label="Número *"
                    :rules="formNumeroFaturamentoErros"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="formComplementoFaturamento" label="Complemento"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="formBairroFaturamento"
                    label="Bairro *"
                    :rules="formBairroFaturamentoErros"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="formCidadeFaturamento"
                    label="Cidade *"
                    :rules="formCidadeFaturamentoErros"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-select
                    v-model="formEstadoFaturamento"
                    :items="formEstados"
                    :rules="[v => !!v || 'Selecione um estado']"
                    label="Estado *"
                    required
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </div>
      </transition>
      <v-checkbox v-model="mesmoRespContrato" color="#AA1623" label="mesmo responsável do contrato"></v-checkbox>
      <transition name="fade">
        <div class="formResponsavelContrao" v-if="!mesmoRespContrato">
          <v-form ref="form6">
            <v-container>
              <v-row>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="formContatoFinanceiro"
                    label="Contato Financeiro *"
                    :rules="formContatoFinanceiroErros"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="formEmailFinanceiro"
                    :rules="emailFinanceiroErrors"
                    label="E-mail *"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="formTelRespFinanceiro"
                    label="Telefone *"
                    :rules="formTelRespFinanceiroErros"
                    v-mask="['(##) ####-####', '(##) # ####-####']"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="formCelRespFinanceiro"
                    label="Celular"
                    v-mask="['(##) # ####-####']"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </div>
      </transition>
      <h3>Endereço de Instalação</h3>
      <v-checkbox
        v-model="mesmoEnderecoEmpresaInstalacao"
        color="#AA1623"
        label="mesmo endereço da empresa"
      ></v-checkbox>
      <transition name="fade">
        <div class="formEnderecoInstalacao" v-if="!mesmoEnderecoEmpresaInstalacao">
          <v-form ref="form7">
            <v-container>
              <v-row>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="formCepInstalacao"
                    label="CEP *"
                    v-mask="maskCep"
                    @keyup="preencherCep3"
                    :rules="formCepInstalacaoErros"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="5">
                  <v-text-field
                    v-model="formEnderecoInstalacao"
                    label="Endereço *"
                    :rules="formEnderecoInstalacaoErros"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="formNumeroInstalacao"
                    label="Número *"
                    :rules="formNumeroInstalacaoErros"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field v-model="formComplementoInstalacao" label="Complemento"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="formBairroInstalacao"
                    :rules="formBairroInstalacaoErros"
                    label="Bairro *"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="formCidadeInstalacao"
                    :rules="formCidadeInstalacaoErros"
                    label="Cidade *"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-select
                    v-model="formEstadoInstalacao"
                    :items="formEstados"
                    :rules="[v => !!v || 'Selecione um estado']"
                    label="Estado *"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="formTelInstalacao"
                    :rules="formTelInstalacaoErros"
                    label="Telefone *"
                    v-mask="['(##) ####-####', '(##) # ####-####']"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="formCelInstalacao"
                    label="Celular"
                    v-mask="['(##) # ####-####']"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </div>
      </transition>
      <!-- <div>
        <h3 align="center">Resumo da Compra</h3>
        <h4 align="center">Tipo de conta: {{ tipoDeConta }}</h4>
        <br />
        <v-toolbar flat>
        <v-toolbar-title></v-toolbar-title>
        <v-spacer></v-spacer>
        </v-toolbar>
        <v-data-table
          dense
          :headers="cabecalhoLista"
          :items="produtosLista"
          item-key="nome"
          class="elevation-1"
          hide-default-footer
        >
          <template v-slot:body.append>
            <tr v-if="subtotalAtivacaoSemDesconto != 0 || subtotalMensalidadeSemDesconto != 0">
              <td></td>
              <td></td>
              <td
                v-if="subtotalAtivacaoSemDesconto != 0"
              >Desconto: {{ subtotalAtivacaoSemDesconto | numeroPreco }}</td>
              <td v-else></td>
              <td
                v-if="subtotalMensalidadeSemDesconto != 0"
              >Desconto: {{ subtotalMensalidadeSemDesconto | numeroPreco }}</td>
              <td v-else></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td>Total {{ totalAtivacaoComDesconto | numeroPreco }} em {{ parcelaAtivacao }}</td>
              <td>Total {{ totalMensalidadeComDesconto | numeroPreco }}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <br />-->
      <div>
        <transition mode="out-in" v-if="mensagemInfo != ''">
          <span class="mensagemInfo">{{ mensagemInfo }}</span>
        </transition>
      </div>
      <v-btn outlined large color="#AA1623" light @click.prevent="validate()" type="submit">Enviar</v-btn>
    </div>
    <br />
    <br />
    <footer>
      <p class="footer">Vetorial Tecnologia - {{ anoAtual }}</p>
    </footer>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import Swal from "sweetalert2";

export default {
  name: "Form",
  data() {
    return {
      emailCliente: "",
      codigoCliente: "",
      mostraFormulario: true,
      mesmoRespTec: false,
      mesmoRespAdm: false,
      mesmoEnderecoEmpresa: false,
      mesmoRespContrato: false,
      mesmoEnderecoEmpresaInstalacao: false,
      formNome: "",
      formNomeErros: [v => !!v || "O nome não pode ficar em branco"],
      formCpf: "",
      formEmail: "",
      formRG: "",
      formIE: "",
      formIM: "",
      formNomeFantasia: "",
      formRGErros: [v => !!v || "RG não pode ficar em branco"],
      formIEErros: [v => !!v || "Inscrição Estadual não pode ficar em branco"],
      formIMErros: [v => !!v || "Inscrição Municipal não pode ficar em branco"],
      formNomeFantasiaErros: [
        v => !!v || "Nome fantasia não pode ficar em branco"
      ],
      formCnpj: "",

      formCep: "",
      formCepFalso: false,
      formEndereco: "",
      formNumero: "",
      formComplemento: "",
      formBairro: "",
      formCidade: "",
      formEstados: [
        "AC",
        "AL",
        "AP",
        "AM",
        "BA",
        "CE",
        "DF",
        "ES",
        "GO",
        "MA",
        "MT",
        "MS",
        "MG",
        "PA",
        "PB",
        "PR",
        "PE",
        "PI",
        "RJ",
        "RN",
        "RS",
        "RO",
        "RR",
        "SC",
        "SP",
        "SE",
        "TO"
      ],
      formEstado: "",
      formVencimento: "10",
      formVencimentos: ["10", "20"],
      formTel1: "",
      formTel2: "",
      formCel: "",
      formNomeRespContrato: "",
      formCpfRespContrato: "",
      formCargoRespContrato: "",
      formEmailRespContrato: "",
      formTelRespContrato: "",
      formCelRespContrato: "",
      formNomeRespTecnico: "",
      formCpfRespTecnico: "",
      formCargoRespTecnico: "",
      formEmailRespTecnico: "",
      formTelRespTecnico: "",
      formCelRespTecnico: "",
      formNomeRespAdministrativo: "",
      formCpfRespAdministrativo: "",
      formCargoRespAdministrativo: "",
      formEmailRespAdministrativo: "",
      formTelRespAdministrativo: "",
      formCelRespAdministrativo: "",
      formCepFaturamento: "",
      formCepFaturamentoFalso: false,
      formEnderecoFaturamento: "",
      formNumeroFaturamento: "",
      formComplementoFaturamento: "",
      formBairroFaturamento: "",
      formCidadeFaturamento: "",
      formEstadoFaturamento: "",
      formContatoFinanceiro: "",
      formEmailFinanceiro: "",
      formTelRespFinanceiro: "",
      formCelRespFinanceiro: "",
      formCepInstalacao: "",
      formCepInstalacaoFalso: false,
      formEnderecoInstalacao: "",
      formNumeroInstalacao: "",
      formComplementoInstalacao: "",
      formBairroInstalacao: "",
      formCidadeInstalacao: "",
      formEstadoInstalacao: "",
      formTelInstalacao: "",
      formCelInstalacao: "",

      cpfErrors: [
        v => !!v || "O CPF deve ser informado",
        v => v.length == 14 || "CPF inválido"
      ],
      codigoClienteErros: [v => !!v || "O código precisa ser preenchido."],
      cpfErrorsContrato: [
        v => !!v || "O CPF deve ser informado",
        v => v.length == 14 || "CPF inválido"
      ],
      cnpjErrors: [
        v => !!v || "O CNPJ deve ser informado",
        v => v.length == 18 || "CNPJ inválido"
      ],
      emailRespContratoErrors: [
        v => !!v || "O e-mail deve ser informado",
        v => /.+@.+\..+/.test(v) || "O e-mail não é válido"
      ],
      emailErrors: [
        v => !!v || "O e-mail deve ser informado",
        v => /.+@.+\..+/.test(v) || "O e-mail não é válido"
      ],
      cpfRespTecnicoErrors: [v => v.length == 14 || "CPF inválido"],
      emailRespTecnicoErrors: [
        v => /.+@.+\..+/.test(v) || "O e-mail não é válido"
      ],
      cpfRespAdministrativoErrors: [v => v.length == 14 || "CPF inválido"],
      emailRespAdministrativoErrors: [
        v => /.+@.+\..+/.test(v) || "O e-mail não é válido"
      ],
      emailFinanceiroErrors: [
        v => !!v || "O e-mail deve ser informado",
        v => /.+@.+\..+/.test(v) || "O e-mail não é válido"
      ],

      formCepErros: [
        v => !!v || "CEP não pode ficar em branco",
        v => v.length == 10 || "O CEP precisa ter 8 dígitos"
      ],
      formEnderecoErros: [v => !!v || "O endereço tem que ser preenchido"],
      formNumeroErros: [v => !!v || "O número tem que ser informado"],
      formBairroErros: [v => !!v || "O bairro não pode ficar em branco"],
      formCidadeErros: [v => !!v || "A cidade não pode ficar em branco"],
      formTel1Erros: [v => !!v || "Um telefone tem que ser informado"],
      formNomeRespContratoErros: [
        v => !!v || "O Nome não pode ficar em branco"
      ],
      formCargoRespContratoErros: [
        v => !!v || "O cargo não pode ficar em branco"
      ],
      formTelRespContratoErros: [
        v => !!v || "Um telefone tem que ser informado"
      ], //, v => /^[0-9]+$/.test(v) || 'Somente números' ],
      //formCelRespContratoErros: [ v => !v || /^[0-9]+$/.test(v) || 'Somente números' ],
      //formTelRespTecnicoErros: [ v => !v || /^[0-9]+$/.test(v) || 'Somente números' ],
      //formCelRespTecnicoErros: [ v => !v || /^[0-9]+$/.test(v) || 'Somente números' ],
      //formTelRespAdministrativoErros: [ v => !v || /^[0-9]+$/.test(v) || 'Somente números' ],
      //formCelRespAdministrativoErros: [ v => !v || /^[0-9]+$/.test(v) || 'Somente números' ],
      formCepFaturamentoErros: [
        v => !!v || "CEP não pode ficar em branco",
        v => v.length == 10 || "O CEP precisa ter 8 dígitos"
      ], //v => /^[0-9]+$/.test(v) || 'Somente números' ],
      formEnderecoFaturamentoErros: [
        v => !!v || "O endereço tem que ser preenchido"
      ],
      formNumeroFaturamentoErros: [
        v => !!v || "O número tem que ser informado"
      ],
      formBairroFaturamentoErros: [
        v => !!v || "O bairro não pode ficar em branco"
      ],
      formCidadeFaturamentoErros: [
        v => !!v || "A cidade não pode ficar em branco"
      ],
      formContatoFinanceiroErros: [
        v => !!v || "O Nome não pode ficar em branco"
      ],
      formTelRespFinanceiroErros: [
        v => !!v || "O número tem que ser informado"
      ],
      //v => /^[0-9]+$/.test(v) || 'Somente números' ],
      //formCelRespFinanceiroErros: [ v => !v || /^[0-9]+$/.test(v) || 'Somente números' ],
      formCepInstalacaoErros: [
        v => !!v || "CEP não pode ficar em branco",
        v => v.length == 10 || "O CEP precisa ter 8 dígitos"
      ],
      //v => /^[0-9]+$/.test(v) || 'Somente números' ],
      formEnderecoInstalacaoErros: [
        v => !!v || "O endereço tem que ser preenchido"
      ],
      formNumeroInstalacaoErros: [v => !!v || "O número tem que ser informado"],
      formBairroInstalacaoErros: [
        v => !!v || "O bairro não pode ficar em branco"
      ],
      formCidadeInstalacaoErros: [
        v => !!v || "A cidade não pode ficar em branco"
      ],
      formTelInstalacaoErros: [v => !!v || "O número tem que ser informado"],
      //v => /^[0-9]+$/.test(v) || 'Somente números' ],
      //formCelInstalacaoErros: [ v => !v || /^[0-9]+$/.test(v) || 'Somente números' ],

      anoAtual: new Date().getFullYear(),
      mensagemInfo: "",
      maskCpf: "###.###.###-##",
      maskCnpj: "##.###.###/####-##",
      maskCep: "##.###-###",
      respostaJson: [],
      dadosPessoais: "",
      enderecoEContato: "",
      dadosResponsavelContrato: "",
      dadosResponsavelTecnico: "",
      dadosResponsavelAdministrativo: "",
      dadosMesmoEnderecoEmpresaFaturamento: "",
      dadosResponsavelFaturamento: "",
      dadosEnderecoInstalacao: "",
      produtosLista: [],
      cabecalhoLista: [
        {
          text: "Nome",
          align: "left",
          sortable: false,
          value: "nome"
        },
        { text: "Vigência", value: "vigencia" },
        { text: "Valor de Ativação", value: "ativacao_valor" },
        { text: "Mensalidade", value: "mensalidade_valor" }
      ],
      idLogin: "",
      subtotalAtivacaoSemDesconto: "",
      subtotalMensalidadeSemDesconto: "",
      totalAtivacaoComDesconto: "",
      totalMensalidadeComDesconto: "",
      tipoPessoa: "",
      parcelaAtivacao: ""
    };
  },
  directives: {
    mask
  },
  // watch: {
  //   mesmoRespTec() {
  //     console.log(this.mesmoRespTec);
  //   }
  // },
  filters: {
    numeroPreco(valor) {
      return valor.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL"
      });
    }
  },
  methods: {
    numeroPreco(valor) {
      return valor.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL"
      });
    },
    mensagem(mensagem) {
      this.mensagemInfo = mensagem;
      setTimeout(() => {
        this.mensagemInfo = "";
      }, 2500);
    },
    async preencherCep1() {
      const cep = this.formCep.replace(/\D/g, "");
      var dados = new FormData();
      dados.append("cep", cep);
      if (cep.length === 8) {
        await fetch(`https://canicontrol.vetorial.net/corp/v1/cep`, {
          method: "POST",
          headers: {
            Authorization: this.base64()
          },
          body: dados
        })
          .then(r => r.json())
          .then(r => {
            if (r.message == "ok") {
              this.formEndereco = r.dados.logradouro;
              this.formBairro = r.dados.bairro;
              this.formCidade = r.dados.localidade;
              this.formCepFalso = false;
              this.formEstado = this.formEstados.some(
                resp => r.dados.uf === resp
              )
                ? r.dados.uf
                : false;
            } else {
              this.formCepErros = ["CEP não localizado"];
              setTimeout(() => {
                this.formCepErros = [
                  v => !!v || "CEP não pode ficar em branco",
                  v => v.length == 10 || "O CEP precisa ter 8 dígitos"
                ];
              }, 2500);
              this.formCepFalso = true;
            }
          });
      }
    },
    async preencherCep2() {
      const cep = this.formCepFaturamento.replace(/\D/g, "");
      var dados = new FormData();
      dados.append("cep", cep);
      if (cep.length === 8) {
        await fetch(`https://canicontrol.vetorial.net/corp/v1/cep`, {
          method: "POST",
          headers: {
            Authorization: this.base64()
          },
          body: dados
        })
          .then(r => r.json())
          .then(r => {
            if (r.message == "ok") {
              this.formEnderecoFaturamento = r.dados.logradouro;
              this.formBairroFaturamento = r.dados.bairro;
              this.formCidadeFaturamento = r.dados.localidade;
              this.formCepFaturamentoFalso = false;
              this.formEstadoFaturamento = this.formEstados.some(
                resp => r.dados.uf === resp
              )
                ? r.dados.uf
                : false;
            } else {
              this.formCepFaturamentoErros = ["CEP não localizado"];
              setTimeout(() => {
                this.formCepFaturamentoErros = [
                  v => !!v || "CEP não pode ficar em branco",
                  v => v.length == 10 || "O CEP precisa ter 8 dígitos"
                ];
              }, 2500);
              this.formCepFaturamentoFalso = true;
            }
          });
      }
    },
    async preencherCep3() {
      const cep = this.formCepInstalacao.replace(/\D/g, "");
      var dados = new FormData();
      dados.append("cep", cep);
      if (cep.length === 8) {
        await fetch(`https://canicontrol.vetorial.net/corp/v1/cep`, {
          method: "POST",
          headers: {
            Authorization: this.base64()
          },
          body: dados
        })
          .then(r => r.json())
          .then(r => {
            if (r.message == "ok") {
              this.formEnderecoInstalacao = r.dados.logradouro;
              this.formBairroInstalacao = r.dados.bairro;
              this.formCidadeInstalacao = r.dados.localidade;
              this.formCepInstalacaoFalso = false;
              this.formEstadoInstalacao = this.formEstados.some(
                resp => r.dados.uf === resp
              )
                ? r.dados.uf
                : false;
            } else {
              this.formCepInstalacaoErros = ["CEP não localizado"];
              setTimeout(() => {
                this.formCepInstalacaoErros = [
                  v => !!v || "CEP não pode ficar em branco",
                  v => v.length == 10 || "O CEP precisa ter 8 dígitos"
                ];
              }, 2500);
              this.formCepInstalacaoFalso = true;
            }
          });
      }
    },
    validate() {
      let form1 = false;
      let form2 = false;
      let form3 = false;
      let form4 = false;
      let form5 = false;
      let form6 = false;
      let form7 = false;

      if (!this.$refs.form1.validate() || !this.$refs.form2.validate()) {
        this.mensagem("Falta preencher alguns campos.");
      } else {
        form1 = true;
        form2 = true;
        if (this.tipoPessoa == "Física") {
          this.dadosPessoais = {
            nomeCompletoCliente: this.formNome,
            cpfCliente: this.formCpf,
            rgCliente: this.formRG,
            emailCliente: this.formEmail
          };
        } else {
          this.dadosPessoais = {
            nomeCompletoCliente: this.formNome,
            cnpjCliente: this.formCnpj,
            emailCliente: this.formEmail,
            inscEstadual: this.formIE,
            inscMunicipal: this.formIM,
            nomeFantasia: this.formNomeFantasia
          };
        }

        this.enderecoEContato = {
          cepCliente: this.formCep,
          enderecoCliente: this.formEndereco,
          numeroEnderecoCliente: this.formNumero,
          complementoEnderecoCliente: this.formComplemento,
          bairroEnderecoCliente: this.formBairro,
          cidadeEnderecoCliente: this.formCidade,
          estadoEnderecoCliente: this.formEstado,
          vencimentoCliente: this.formVencimento,
          telefoneCliente: this.formTel1,
          telefone2Cliente: this.formTel2,
          celularCliente: this.formCel
        };

        this.dadosResponsavelContrato = {
          nomeContrato: this.formNomeRespContrato,
          cpfContrato: this.formCpfRespContrato,
          cargoContrato: this.formCargoRespContrato,
          emailContrato: this.formEmailRespContrato,
          telefoneContrato: this.formTelRespContrato,
          celularContrato: this.formCelRespContrato
        };
        if (!this.mesmoRespTec) {
          if (!this.$refs.form3.validate()) {
            this.mensagem(
              "A caixa de responsável técnico está desmarcada e tem itens mal ou não preenchidos."
            );
          } else {
            form3 = true;
            this.dadosResponsavelTecnico = {
              nomeRespTecnico: this.formNomeRespTecnico,
              cpfRespTec: this.formCpfRespTecnico,
              cargoRespTecnico: this.formCargoRespTecnico,
              emailRespTecnico: this.formEmailRespTecnico,
              telefoneRespTecnico: this.formTelRespTecnico,
              celularRespTecnico: this.formCelRespTecnico
            };
          }
        } else {
          form3 = true;
          this.dadosResponsavelTecnico = "";
        }
        if (!this.mesmoRespAdm) {
          if (!this.$refs.form4.validate()) {
            this.mensagem(
              "A caixa de responsável administrativo está desmarcada e tem itens mal ou não preenchidos."
            );
          } else {
            form4 = true;
            this.dadosResponsavelAdministrativo = {
              nomeRespAdm: this.formNomeRespAdministrativo,
              cpfRespAdm: this.formCpfRespAdministrativo,
              cargoRespAdm: this.formCargoRespAdministrativo,
              emailRespAdm: this.formEmailRespAdministrativo,
              telefoneRespAdm: this.formTelRespAdministrativo,
              celularRespAdm: this.formCelRespAdministrativo
            };
          }
        } else {
          form4 = true;
          this.dadosResponsavelAdministrativo = "";
        }
        if (!this.mesmoEnderecoEmpresa) {
          if (!this.$refs.form5.validate()) {
            this.mensagem(
              "A caixa de endereço para faturamento está desmarcada e tem itens mal ou não preenchidos."
            );
          } else {
            form5 = true;
            this.dadosMesmoEnderecoEmpresaFaturamento = {
              cepFaturamento: this.formCepFaturamento,
              enderecoFaturamento: this.formEnderecoFaturamento,
              numeroFaturamento: this.formNumeroFaturamento,
              complementoFaturamento: this.formComplementoFaturamento,
              bairroFaturamento: this.formBairroFaturamento,
              cidadeFaturamento: this.formCidadeFaturamento,
              estadoFaturamento: this.formEstadoFaturamento
            };
          }
        } else {
          form5 = true;
        }
        if (!this.mesmoRespContrato) {
          if (!this.$refs.form6.validate()) {
            this.mensagem(
              "A caixa de responsável pelo faturamento está desmarcada e tem itens mal ou não preenchidos."
            );
          } else {
            form6 = true;
            this.dadosResponsavelFaturamento = {
              contatoFinanceiro: this.formContatoFinanceiro,
              emailFinanceiro: this.formEmailFinanceiro,
              telefoneFinanceiro: this.formTelRespFinanceiro,
              celularFinanceiro: this.formCelRespFinanceiro
            };
          }
        } else {
          form6 = true;
        }
        if (!this.mesmoEnderecoEmpresaInstalacao) {
          if (!this.$refs.form7.validate()) {
            this.mensagem(
              "A caixa de endereço para instalação está desmarcada e tem itens mal ou não preenchidos."
            );
          } else {
            form7 = true;
            this.dadosEnderecoInstalacao = {
              cepInstalacao: this.formCepInstalacao,
              enderecoInstalacao: this.formEnderecoInstalacao,
              numeroInstalacao: this.formNumeroInstalacao,
              complementoInstalacao: this.formComplementoInstalacao,
              bairroInstalacao: this.formBairroInstalacao,
              cidadeInstalacao: this.formCidadeInstalacao,
              estadoInstalacao: this.formEstadoInstalacao,
              telefoneInstalacao: this.formTelInstalacao,
              celularInstalacao: this.formCelInstalacao
            };
          }
        } else {
          form7 = true;
        }
      }

      if (form1 && form2 && form3 && form4 && form5 && form6 && form7) {
        this.gravarDados();
      }
    },
    async gravarDados() {
      var dados = new FormData();
      dados.append("dadosPessoais", JSON.stringify(this.dadosPessoais));
      dados.append("enderecoEContato", JSON.stringify(this.enderecoEContato));
      dados.append(
        "responsavelContrato",
        JSON.stringify(this.dadosResponsavelContrato)
      );
      dados.append(
        "responsavelTecnico",
        JSON.stringify(this.dadosResponsavelTecnico)
      );
      dados.append(
        "responsavelAdministrativo",
        JSON.stringify(this.dadosResponsavelAdministrativo)
      );
      dados.append(
        "enderecoFaturamento",
        JSON.stringify(this.dadosMesmoEnderecoEmpresaFaturamento)
      );
      dados.append(
        "responsavelFaturamento",
        JSON.stringify(this.dadosResponsavelFaturamento)
      );
      dados.append(
        "enderecoInstalacao",
        JSON.stringify(this.dadosEnderecoInstalacao)
      );
      await fetch("https://canicontrol.vetorial.net/corp/v1/cliente/salvar", {
        method: "POST",
        body: dados,
        headers: {
          Authorization: this.base64(),
          password: this.codigoCliente,
          clienteid: this.idLogin
        }
      });
      Swal.fire({
        title: "Sucesso",
        icon: "success",
        text: "Formulário enviado com sucesso."
      });
      this.mostraFormulario = true;
      this.emailCliente = "";
      this.codigoCliente = "";
    },
    puxarDados() {
      fetch("https://canicontrol.vetorial.net/corp/v1/login", {
        method: "POST",
        headers: {
          Authorization: this.base64(),
          password: this.codigoCliente,
          email: this.emailCliente
        }
      })
        .then(r => r.json())
        .then(r => {
          if (r.message == "ok") {
            this.mostraFormulario = !this.mostraFormulario;
            this.idLogin = r.id;
            // this.puxarProdutosTabela();
            this.preencheFicha();
          } else {
            Swal.fire({
              title: "Erro",
              icon: "error",
              text:
                "Erro ao carregar o formulário. Por favor, verifique seu código e e-mail e tente novamente."
            });
          }
        });
    },
    // async puxarProdutosTabela() {
    //   //var autenticacao = new FormData();
    //   // autenticacao.append("clienteid", this.idLogin);
    //   // autenticacao.append("password", this.codigoCliente);
    //   await fetch("http://172.16.151.204:9002/v1/cliente/carregar", {
    //     method: "POST",
    //     headers: {
    //       Authorization: this.base64(),
    //       password: this.codigoCliente,
    //       email: this.emailCliente,
    //       clienteid: this.idLogin
    //     }
    //     // body: autenticacao
    //   })
    //     .then(r => r.json())
    //     .then(r => {
    //       let listaNova = r.produtos.map(item => {
    //         item.ativacao_valor = this.numeroPreco(
    //           parseFloat(r.cliente.valor_ativacao)
    //         );
    //         item.mensalidade_valor = this.numeroPreco(
    //           parseFloat(r.cliente.mensalidade)
    //         );
    //         item.vigencia = `${item.vigencia} meses`;
    //         return item;
    //       });
    //       this.produtosLista = listaNova;
    //       this.subtotalAtivacaoSemDesconto = parseFloat(
    //         r.cliente.valor_ativacao_desconto
    //       );
    //       this.subtotalMensalidadeSemDesconto = parseFloat(
    //         r.cliente.mensalidade_desconto
    //       );
    //       this.totalAtivacaoComDesconto =
    //         r.cliente.valor_ativacao - this.subtotalAtivacaoSemDesconto;
    //       this.totalMensalidadeComDesconto =
    //         r.cliente.mensalidade - this.subtotalMensalidadeSemDesconto;
    //       this.tipoPessoa = r.cliente.tipo_pessoa;
    //       if (r.cliente.parcelamento != null && r.cliente.parcelamento > 1) {
    //         this.parcelaAtivacao = r.cliente.parcelamento + " vezes";
    //       } else {
    //         this.parcelaAtivacao = "1 vez";
    //       }
    //     });
    // },
    preencheFicha() {
      fetch("https://canicontrol.vetorial.net/corp/v1/cliente/ficha", {
        method: "POST",
        headers: {
          Authorization: this.base64(),
          password: this.codigoCliente,
          clienteid: this.idLogin
        }
      })
        .then(r => r.json())
        .then(r => {
          if (r.message == "ok" && r.dados != null) {
            const dadosP = r.dados.dadosPessoais;
            if (this.tipoPessoa == "Física") {
              this.formNome = dadosP.nomeCompletoCliente;
              this.formCpf = dadosP.cpfCliente;
              this.formRG = dadosP.rgCliente;
              this.formEmail = dadosP.emailCliente;
            } else {
              this.formNome = dadosP.nomeCompletoCliente;
              this.formCnpj = dadosP.cnpjCliente;
              this.formEmail = dadosP.emailCliente;
              this.formIE = dadosP.inscEstadual;
              this.formIM = dadosP.inscMunicipal;
              this.formNomeFantasia = dadosP.nomeFantasia;
            }

            const enderecoEContato = r.dados.enderecoEContato;
            this.formCep = enderecoEContato.cepCliente;
            this.formEndereco = enderecoEContato.enderecoCliente;
            this.formNumero = enderecoEContato.numeroEnderecoCliente;
            this.formComplemento = enderecoEContato.complementoEnderecoCliente;
            this.formBairro = enderecoEContato.bairroEnderecoCliente;
            this.formCidade = enderecoEContato.cidadeEnderecoCliente;
            this.formEstado = enderecoEContato.estadoEnderecoCliente;
            this.formVencimento = enderecoEContato.vencimentoCliente;
            this.formTel1 = enderecoEContato.telefoneCliente;
            this.formTel2 = enderecoEContato.telefone2Cliente;
            this.formCel = enderecoEContato.celularCliente;

            const dadosResponsavelContrato = r.dados.responsavelContrato;
            this.formNomeRespContrato = dadosResponsavelContrato.nomeContrato;
            this.formCpfRespContrato = dadosResponsavelContrato.cpfContrato;
            this.formCargoRespContrato = dadosResponsavelContrato.cargoContrato;
            this.formEmailRespContrato = dadosResponsavelContrato.emailContrato;
            this.formTelRespContrato =
              dadosResponsavelContrato.telefoneContrato;
            this.formCelRespContrato = dadosResponsavelContrato.celularContrato;

            const responsavelTecnico = r.dados.responsavelTecnico;
            if (responsavelTecnico.length == 0) {
              this.mesmoRespTec = true;
            } else {
              this.formNomeRespTecnico = responsavelTecnico.nomeRespTecnico;
              this.formCpfRespTecnico = responsavelTecnico.cpfRespTec;
              this.formCargoRespTecnico = responsavelTecnico.cargoRespTecnico;
              this.formEmailRespTecnico = responsavelTecnico.emailRespTecnico;
              this.formTelRespTecnico = responsavelTecnico.telefoneRespTecnico;
              this.formCelRespTecnico = responsavelTecnico.celularRespTecnico;
            }

            const responsavelAdministrativo = r.dados.responsavelAdministrativo;
            if (responsavelAdministrativo.length == 0) {
              this.mesmoRespAdm = true;
            } else {
              this.formNomeRespAdministrativo =
                responsavelAdministrativo.nomeRespAdm;
              this.formCpfRespAdministrativo =
                responsavelAdministrativo.cpfRespAdm;
              this.formCargoRespAdministrativo =
                responsavelAdministrativo.cargoRespAdm;
              this.formEmailRespAdministrativo =
                responsavelAdministrativo.emailRespAdm;
              this.formTelRespAdministrativo =
                responsavelAdministrativo.telefoneRespAdm;
              this.formCelRespAdministrativo =
                responsavelAdministrativo.celularRespAdm;
            }

            const enderecoFaturamento = r.dados.enderecoFaturamento;
            if (enderecoFaturamento.length == 0) {
              this.mesmoEnderecoEmpresa = true;
            } else {
              this.formCepFaturamento = enderecoFaturamento.cepFaturamento;
              this.formEnderecoFaturamento =
                enderecoFaturamento.enderecoFaturamento;
              this.formNumeroFaturamento =
                enderecoFaturamento.numeroFaturamento;
              this.formComplementoFaturamento =
                enderecoFaturamento.complementoFaturamento;
              this.formBairroFaturamento =
                enderecoFaturamento.bairroFaturamento;
              this.formCidadeFaturamento =
                enderecoFaturamento.cidadeFaturamento;
              this.formEstadoFaturamento =
                enderecoFaturamento.estadoFaturamento;
            }
            const responsavelFaturamento = r.dados.responsavelFaturamento;
            if (responsavelFaturamento.length == 0) {
              this.mesmoRespContrato = true;
            } else {
              this.formContatoFinanceiro =
                responsavelFaturamento.contatoFinanceiro;
              this.formEmailFinanceiro = responsavelFaturamento.emailFinanceiro;
              this.formTelRespFinanceiro =
                responsavelFaturamento.telefoneFinanceiro;
              this.formCelRespFinanceiro =
                responsavelFaturamento.celularFinanceiro;
            }

            const enderecoInstalacao = r.dados.enderecoInstalacao;
            if (enderecoInstalacao.length == 0) {
              this.mesmoEnderecoEmpresaInstalacao = true;
            } else {
              this.formCepInstalacao = enderecoInstalacao.cepInstalacao;
              this.formEnderecoInstalacao =
                enderecoInstalacao.enderecoInstalacao;
              this.formNumeroInstalacao = enderecoInstalacao.numeroInstalacao;
              this.formComplementoInstalacao =
                enderecoInstalacao.complementoInstalacao;
              this.formBairroInstalacao = enderecoInstalacao.bairroInstalacao;
              this.formCidadeInstalacao = enderecoInstalacao.cidadeInstalacao;
              this.formEstadoInstalacao = enderecoInstalacao.estadoInstalacao;
              this.formTelInstalacao = enderecoInstalacao.telefoneInstalacao;
              this.formCelInstalacao = enderecoInstalacao.celularInstalacao;
            }
          } else if (r.message == "not found") {
            this.carregaFicha();
          } else
            Swal.fire({
              title: "Erro",
              icon: "error",
              text: "Ocorreu um erro ao carregar a ficha."
            });
        });
    },
    base64() {
      let data = new Date(),
        dia = data.getDate().toString(),
        diaF = dia.length == 1 ? "0" + dia : dia,
        mes = (data.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
        mesF = mes.length == 1 ? "0" + mes : mes;
      let base64 = "Basic " + btoa(`corporativoCliente:${diaF}${mesF}`);
      // let base64 = atob("Y29ycG9yYXRpdm9DbGllbnRlOjA3MDI=")
      return base64;
      // console.log(base64)
    },
    carregaFicha() {
      // var autenticacao = new FormData();
      // autenticacao.append("clienteid", this.idLogin);
      // autenticacao.append("password", this.codigoCliente);
      fetch("https://canicontrol.vetorial.net/corp/v1/cliente/carregar", {
        method: "POST",
        headers: {
          Authorization: this.base64(),
          clienteid: this.idLogin,
          password: this.codigoCliente,
          email: this.emailCliente
        }
        //body: autenticacao
      })
        .then(r => r.json())
        .then(r => {
          if (r.message == "ok") {
            this.formNome = r.cliente.nome;
            this.formEmail = r.cliente.email;
            this.tipoPessoa = r.cliente.tipo_pessoa;

            // this.subtotalAtivacaoSemDesconto = r.cliente.valor_ativacao
            // this.subtotalMensalidadeSemDesconto = r.cliente.mensalidade
          }
        });
    }
  },
  created() {
    // this.base64();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.topo {
  align-content: center;
  margin: 0 auto;
  width: 100%;
  height: 100px;
  background: #aa1623;
}
.mensagemInfo {
  font-size: 14px;
  color: #aa1623;
}
.ctn h2,
h3 {
  padding: 10px;
  /*font-family: Georgia, 'Times New Roman', Times, serif;*/
  border-bottom: solid #708090;
}
.formResponsavel h3 {
  padding: 10px;
  /*font-family: Georgia, 'Times New Roman', Times, serif;*/
  border-bottom: solid #708090;
}
.footer {
  position: absolute;
  bottom: 0;
  width: 80%;
  text-align: center;
  /* padding-top: 30px; */
  font-size: 1.2em;
  z-index: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}
.obrigatorios {
  color: red;
  font-size: 0.7em;
}
</style>
